var map = {
	"./CUIABA/gazetaTopo1.png": "pnxH",
	"./DOE-AL/gazetaTopo1.png": "cc0X",
	"./PMVG/gazetaTopo1.png": "Z+Yt",
	"./TCE-AL/gazetaTopo1.png": "qDLD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mF9N";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens ^\.\/.*\/gazetaTopo1\.png$
// module id = mF9N
// module chunks = 1